import React from 'react';
import { Segment, Card, Icon, Button, Popup, Label } from 'semantic-ui-react';
import axios from 'axios';
import numeral from 'numeral';
import _ from 'lodash';

import DataFetchError from '../data-fetch-error';
import { authService } from '../../utils/auth-service';

import GridLayout from './grid-layout';
import ListLayout from './list-layout';

class InfluencerAdPosts extends React.Component {

  state = { items: [], loading: true, layout: 'list', allPosts: false, smallImages: true }

  constructor() {
    super();
    const token = authService.getToken();
    const newsfeedApi = process.env.REACT_APP_NEWSFEED_API;
    this.api = axios.create({
      baseURL: newsfeedApi,
      timeout: 5000,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  componentDidMount() {
    const { influencer } = this.props;
    const handle = influencer.instagram;
    this.api.get(`/handle/${handle}`)
      .then(response => {
        const { items } = response.data.data;
        this.setState({
          items,
          loading: false,
        });
      })
      .catch(error => {
        this.setState({
          error,
          loading: false,
        });
      });
  }

  getSaturationLevel = saturation => {
    if (saturation < 0.25) return 'green';
    if (saturation < 0.5) return 'orange';
    return 'red';
  }

  render() {
    const { layout, allPosts, smallImages } = this.state;
    const { items, loading, error } = this.state;

    const totalPosts = items.length;
    const numberOfAds = _.filter(items, item => (item.isAd)).length;
    const saturation = numberOfAds / totalPosts;
    const saturationFormatted = numeral(saturation).format('0.0%');
    const saturationLevel = this.getSaturationLevel(saturation);

    const imageSizeContent = `Currently showing posts with ${smallImages ? 'small' : 'large'} images`;
    const adPostsContent = `Currently showing ${allPosts ? 'all' : 'only #ad'} posts`;

    const SaturationInfo = () => (
      <Popup
        trigger={<Icon name="help circle outline" color="blue" />}
        content="#ad saturation is calculated by dividing number of #ad posts by total number of posts"
      />
    );

    const pLeft = {
      fontSize: '90%',
      fontWeight: 'bold',
      display: 'inline-block',
      width: '365px',
    };

    const pCenter = _.assign({
      textAlign: 'center',
    }, pLeft);

    const pRight = _.assign({
      textAlign: 'right',
    }, pLeft);

    return (
      <div className="page-content">
        <Segment basic loading={loading}>
          <Card fluid>
            <Card.Content>
              <Button.Group floated="right">
                <Popup
                  trigger={
                    <Button
                      toggle
                      active={smallImages}
                      icon
                      onClick={() => this.setState({ smallImages: !smallImages })}
                    >
                      {
                        smallImages
                        ? <Icon name="list layout" />
                        : <Icon name="image" />
                      }
                    </Button>
                  }
                  content={imageSizeContent}
                />
                <Popup
                  trigger={
                    <Button toggle active={!allPosts} icon onClick={() => this.setState({ allPosts: !allPosts })}>
                      <Icon name="money" />
                    </Button>
                  }
                  content={adPostsContent}
                />
              </Button.Group>

              <p style={pLeft}>
                Out of the last { totalPosts } Instagram posts, { numberOfAds } were tagged #ad.
              </p>
              <p style={pCenter}>
                <Label basic color="grey">#ad saturation&nbsp;<SaturationInfo /></Label> = <Label basic color={saturationLevel} content={saturationFormatted} />
              </p>
              <p style={pRight}>
                Toggle to view all posts and adjust view settings <Icon name="chevron right" />
              </p>

            </Card.Content>

            <Card.Content>


              {
                layout === 'grid' &&
                <GridLayout items={items} />
              }
              {
                layout === 'list' &&
                <ListLayout items={items} allPosts={allPosts} smallImages={smallImages} />
              }


              {
                error && <DataFetchError dataDescription="newsfeed data" iconSize="massive" error={error} />
              }
            </Card.Content>
          </Card>
        </Segment>
      </div>
    );
  }
}


export default InfluencerAdPosts;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-ad-posts/index.js
 **/